// One approved robot onboarding plan — `/internal/robot-plans/:planId`, where
// the param is the RobotApprovedPlan row id (not the agent's planId).
import { createFileRoute } from '@tanstack/react-router';

import { RobotPlanDetailPage } from '../../../components/robot-plans/RobotPlanDetailPage';
import { guardSuperuser } from '../index';

export const Route = createFileRoute('/internal/robot-plans/$planId')({
  beforeLoad: () => guardSuperuser(),
  component: RobotPlanDetailRoute,
});

function RobotPlanDetailRoute() {
  const { planId } = Route.useParams();
  return <RobotPlanDetailPage key={planId} id={planId} />;
}
